'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    DataTr: ()=>DataTr,
    DataTrExpandable: ()=>DataTrExpandable
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const collapsible_namespaceObject = require("@base-ui-components/react/collapsible");
const external_react_namespaceObject = require("react");
const index_cjs_namespaceObject = require("../Checkbox/index.cjs");
const external_Table_index_cjs_namespaceObject = require("../Table/index.cjs");
const external_DataTable_variants_cjs_namespaceObject = require("./DataTable.variants.cjs");
const external_DataTd_cjs_namespaceObject = require("./DataTd.cjs");
const DataRow = ({ table, row })=>{
    const handleRowSelect = (0, external_react_namespaceObject.useCallback)((row)=>(_value, e)=>{
            row.getToggleSelectedHandler()(e);
        }, []);
    const parentRow = row.getParentRow();
    const hasParent = Boolean(parentRow);
    const styles = (0, external_DataTable_variants_cjs_namespaceObject.rowVariants)();
    const isOpen = parentRow ? parentRow.getIsExpanded() : true;
    return hasParent ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(collapsible_namespaceObject.Collapsible.Root, {
        render: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("tr", {}),
        open: isOpen,
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(collapsible_namespaceObject.Collapsible.Panel, {
                render: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Table_index_cjs_namespaceObject.Td, {
                    className: styles.panel()
                })
            }),
            table.options.enableMultiRowSelection && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(collapsible_namespaceObject.Collapsible.Panel, {
                render: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Table_index_cjs_namespaceObject.Td, {
                    className: styles.panel()
                }, `${row.id}-tr-td-checkbox`),
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.Checkbox, {
                    checked: row.getIsSelected(),
                    handleChange: handleRowSelect(row),
                    disabled: !row.getCanSelect(),
                    "aria-label": `Select row ${row.id}`,
                    value: '',
                    name: `row-${row.id}-checkbox`
                })
            }),
            row.getVisibleCells().map((cell)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(collapsible_namespaceObject.Collapsible.Panel, {
                    render: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_DataTd_cjs_namespaceObject.DataTd, {
                        table: table,
                        row: row,
                        cell: cell,
                        className: styles.panel()
                    }, cell.id)
                }, cell.id))
        ]
    }) : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_Table_index_cjs_namespaceObject.Tr, {
        children: [
            table.options.enableMultiRowSelection && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Table_index_cjs_namespaceObject.Td, {
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.Checkbox, {
                    checked: row.getIsSelected(),
                    handleChange: handleRowSelect(row),
                    disabled: !row.getCanSelect(),
                    "aria-label": `Select row ${row.id}`,
                    value: '',
                    name: `row-${row.id}-checkbox`
                })
            }, `${row.id}-tr-td-checkbox`),
            row.getVisibleCells().map((cell)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_DataTd_cjs_namespaceObject.DataTd, {
                    table: table,
                    row: row,
                    cell: cell,
                    className: "element"
                }, cell.id))
        ]
    });
};
const DataTrDrawer = ({ table, row })=>{
    const drawerContent = table.options.meta?.drawerContent?.({
        row
    });
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_Table_index_cjs_namespaceObject.TrDrawer, {
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(DataRow, {
                table: table,
                row: row
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Table_index_cjs_namespaceObject.TrDrawerContent, {
                children: /*#__PURE__*/ (0, external_react_namespaceObject.isValidElement)(drawerContent) && drawerContent
            })
        ]
    });
};
const DataTrExpandable = ({ table, row })=>{
    const { setPlaceholder } = (0, external_Table_index_cjs_namespaceObject.useTableContext)();
    const isExpanded = row.getIsExpanded();
    (0, external_react_namespaceObject.useEffect)(()=>{
        setPlaceholder(true);
    }, [
        setPlaceholder
    ]);
    const expandableContext = (0, external_react_namespaceObject.useMemo)(()=>({
            isExpandable: true,
            isExpanded,
            setIsExpanded: ()=>{
                row.toggleExpanded();
            }
        }), [
        isExpanded,
        row
    ]);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Table_index_cjs_namespaceObject.TableRowExpandableContext.Provider, {
        value: expandableContext,
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(DataRow, {
            table: table,
            row: row
        })
    });
};
const DataTr = ({ table, row })=>{
    const isExpandable = table.options.getRowCanExpand?.(row) ?? true;
    const drawerContent = table.options.meta?.drawerContent;
    if (isExpandable) {
        if (drawerContent) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(DataTrDrawer, {
            table: table,
            row: row
        });
        if (0 === row.depth && row.subRows.length > 0) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(DataTrExpandable, {
            table: table,
            row: row
        });
    }
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(DataRow, {
        table: table,
        row: row
    });
};
exports.DataTr = __webpack_exports__.DataTr;
exports.DataTrExpandable = __webpack_exports__.DataTrExpandable;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "DataTr",
    "DataTrExpandable"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
